import type { FaireProductEntity } from "../../entity_types/product";

export const p_9b3e3fuvnt: FaireProductEntity = {
  token: "p_9b3e3fuvnt",
  type: "product",
  name: "MENS | Two-Tone Sailors Knot Leather Rope Bracelet",
  brandToken: "b_e5eaca89",
  brandName: "Diana Kauffman Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/163df4b4ccc14a49f3a38e1e49ec7eaddc9cde94cc4d093ad2ef51aae7caf7b9.jpeg",
  galleryImageUrls: [],
  priceDollars: 26,
  description:
    'Simple, braided leather with a focal "sailor\'s knot" finished in a strong and durable magnetic clasp.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n• Color: Natural/Tobacco Brown\n• w: 10mm\n• Length:\n• 8" will fit wrist sizes up to 7.5"\n• 8.5" will fit wrist sizes up to 8"\n• Lead & Nickel Free\n• 99.9% Sterling Silver plated clasp.\n\nOur men\'s collection is how we started our jewelry line in 2013. Diana wanted to make a bracelet for her husband that she didn\'t see on the market. Nothing too surfer dude, nothing too fancy. Just strong, handsome, stylish. Over the years women usurped these pieces and we started our women\'s line. But truly these pieces cane worn by all: they are timeless classics.\n\n• Each piece arrives with an artisan card that tells your customer about Diana Kauffman Designs and how to care for their jewelry.',
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:48.233Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
